const defaultRender = (value) => (value ? value : '--');

const faqColumn = [
    {
        title: 'Quetions',
        dataIndex: 'question',
        render: defaultRender,
    },
    {
        title: 'Answer',
        dataIndex: 'answer',
        render: defaultRender,
    },
    {
        title:'Status',
        dataIndex: 'status',
        render: defaultRender,
    },
    {
        title:'Action',
        dataIndex: 'action',
    },
];

export default faqColumn; 